import * as React from 'react';
import { memo, type JSX } from 'react';
import { useTranslation } from 'next-i18next';

import { openInNewTab, cn } from '@restworld/utils-common';
import { Button, Heading } from '@restworld/ui-ds-base';

/* eslint-disable-next-line */
export interface JobNotFoundPageProps {
  title?: string;
  subTitle?: string;
  className?: string;
  icon?: JSX.Element;
  primaryButtonProps?: {
    title?: string;
    onClick?: () => void;
  };
  secondaryButtonProps?: {
    title?: string;
    onClick?: () => void;
  };
}
export const JobNotFoundPage = memo(
  ({
    title,
    subTitle,
    className,
    icon,
    primaryButtonProps: { title: primaryBtnTitle, onClick: primaryBtnOnClick = () => openInNewTab(`/worker`) } = {},
    secondaryButtonProps,
  }: JobNotFoundPageProps) => {
    const { t } = useTranslation();
    return (
      <Wrapper className={className}>
        {icon}
        <Heading size={4} weight="semibold">
          {title ?? t('common:location_not_found_we_looked_everywhere')}
        </Heading>
        <Heading size={5} weight="normal" color="muted">
          {subTitle ?? t('common:the_location_may_be_non_existent_or_no_longer_active')}
        </Heading>
        <Button variant={!secondaryButtonProps ? 'secondary-neutral' : 'primary'} onClick={primaryBtnOnClick} fullwidth>
          {primaryBtnTitle ?? t('common:back_to_search')}
        </Button>
        {!!secondaryButtonProps && (
          <Button variant="secondary-neutral" onClick={secondaryButtonProps.onClick} fullwidth>
            {secondaryButtonProps.title}
          </Button>
        )}
      </Wrapper>
    );
  }
);

export default JobNotFoundPage;
const Wrapper = ({ className, ...props }: any) => (
  <div
    className={cn('flex flex-col gap-4 justify-center max-w-sm text-center w-full items-center mx-auto', className)}
    {...props}
  />
);
